import type { MirageServer, MockServer } from '../server.js'

export function seeds(server: MockServer) {
  void server.lazySeedingManager?.seedBasic('Diagnosis')
}

export function routes(server: MockServer) {
  // GET /codelist/diagnoses/v1 - Get diagnosis options for multi-select
  server.get(
    '/codelist/diagnoses/v1',
    function (this: MirageServer, schema, request) {
      const allDiagnoses = schema.all('diagnosis')
      const search = request.queryParams['filter[search]']

      let filteredDiagnoses = allDiagnoses.models

      if (search) {
        const searchValue = Array.isArray(search) ? search[0] : search
        const searchLower = searchValue.toLowerCase()
        filteredDiagnoses = filteredDiagnoses.filter(
          (diag) =>
            String(diag.attrs.code)?.toLowerCase().includes(searchLower) ||
            diag.attrs.label?.toLowerCase().includes(searchLower),
        )
      }

      return {
        data: filteredDiagnoses.map((diag) => ({
          id: diag.id,
          type: 'Diagnosis',
          attributes: {
            id: diag.id,
            code: diag.attrs.code,
            label: diag.attrs.label,
          },
        })),
      }
    },
  )
}
